import React from 'react';
import { t } from 'i18next';
import { useFormik } from 'formik';
import { FilterSelectNative } from '@/components/custom/filter';
import LessonCard from './LessonCard';
import usePermission from '@/hooks/usePermission';

export default function TabLessons({ currentModule }) {
  const bnccPermission = usePermission('Visualizar habilidades BNCC das aulas', 'Cursos');

  const filters = useFormik({
    initialValues: {
      searchTerm: '',
      discipline: 'blank'
    }
  });

  const lessons = currentModule?.['learning-system-contents']?.filter(item => item?.learning_system_items?.length > 0);
  const learningSystemItems = lessons?.flatMap(item => (item?.learning_system_items?.length > 0 ? item?.learning_system_items.map(learningSystemItem => ({ ...learningSystemItem, discipline_name: item.body })) : []));

  const filteredItems = learningSystemItems?.filter(item => {
    const matchSearch = filters.values.searchTerm ? item.body.toLowerCase().includes(filters.values.searchTerm.toLowerCase()) : true;

    const matchDiscipline = filters.values.discipline !== 'blank' ? item.discipline_name === filters.values.discipline : true;

    return matchSearch && matchDiscipline;
  });

  return (
    <div className="animate-fade-in">
      <div className="filter-bar filter-bar--borderless">
        <div className="filter-bar__inner">
          <div className="filter-bar__row">
            <label
              htmlFor="search"
              className="filter-bar__label"
            >
              {t('textsCommon.search')}
            </label>
            <input
              className="form__control form__control--search-with-icon"
              placeholder="Pesquisar por aula"
              type="search"
              name="search"
              id="search"
              onChange={e => filters.setFieldValue('searchTerm', e.target.value)}
            />
          </div>

          <FilterSelectNative
            blankLabel={t('filter.blankLabelAll2')}
            label={'Selecione uma disciplina'}
            value={filters.values.discipline}
            onChange={e => filters.setFieldValue('discipline', e.target.value)}
            options={currentModule?.['learning-system-contents']?.map(discipline => ({
              name: discipline.body,
              value: discipline.id
            }))}
          />
        </div>
      </div>

      <div className="round-dg-wrapper">
        <table
          className="round-dg round-dg--light"
          style={{ minWidth: '800px' }}
        >
          <thead className="round-dg__header">
            <tr className="round-dg__row">
              <th
                className="round-dg__cell-header"
                style={{ width: '250px' }}
              >
                Nome da aula
              </th>
              {bnccPermission && <th className="round-dg__cell-header w-32 md:w-96">Código</th>}
              <th
                className="round-dg__cell-header"
                style={{ width: '140px' }}
              >
                Arquivos da aula
              </th>
              <th
                className="round-dg__cell-header"
                style={{ width: '94px' }}
              >
                Duração
              </th>
              <th
                className="round-dg__cell-header"
                style={{ width: '156px' }}
              />
            </tr>
          </thead>

          <tbody className="round-dg__body">
            {filteredItems?.length > 0 &&
              filteredItems?.map(item => (
                <LessonCard
                  key={item.id}
                  data={item}
                  moduleId={currentModule.id}
                />
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
